import React, { Component } from "react";

import ContactFooter from "./contactFooter/ContactFooter";
import { withRouter } from "react-router-dom";
/****************************************
    Footer of Content
    @author  IMH003
    @date    2020.05.10
    @version 0.1    
 ******************************************/

class Footer extends Component {
    render() {
        var footerString =
            "주체109(2020)년 | <nobr>조선민주주의인민공화국</nobr> <nobr>국가관광총국</nobr>";
        var footerString_en =
            "Juche 109(2020) | <nobr>DPR Korea</nobr> <nobr>National Tourism Administration</nobr>";
        return (
            (this.props.history.location.pathname.split("/")[1] !=
                "revolution" ||
                this.props.history.location.pathname.split("/")[2] === "" ||
                    this.props.history.location.pathname.split("/").length ==
                        2) && (
                <div id="footer">
                    <ContactFooter />
                    <div className="footer">
                        <div className="container">
                            <div className="mt-3 justify-content-center">
                                <div className="row">
                                    <div
                                        className="col-md-12 col-sm-12 padding-top-10 mb-3"
                                        style={{ fontSize: "16px" }}
                                        dangerouslySetInnerHTML={{
                                            __html: footerString_en,
                                        }}
                                    />
                                </div>
                                <div className="row">
                                    <div
                                        className="col-md-12 col-sm-12 padding-top-10 mb-3"
                                        style={{ fontSize: "16px" }}
                                        dangerouslySetInnerHTML={{
                                            __html: footerString,
                                        }}
                                    />
                                </div>
                            </div>
                            <div tyle={{ width: "300px" }}>
                                <a
                                    href="http://www.dprkportal.kp/"
                                    target="_blank"
                                >
                                    <img
                                        src="/assets/images/gwangya-mark.jpg"
                                        alt="gwangya mark"
                                        style={{ width: "180px" }}
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )
        );
    }
}

export default withRouter(Footer);
